import createClient, { type Client } from 'openapi-fetch';

import type { paths } from './generated/schema';

export type ApiClient = Client<paths>;

// Every client sends credentials (the kc_session cookie) and X-KC-CSRF to satisfy
// the api's CSRF guard. `baseUrl` is the api origin — each operation path carries
// its own version (`/v1/…`), so a single endpoint can bump version on its own.
function build(baseUrl: string, extraHeaders?: Record<string, string>): ApiClient {
	return createClient<paths>({
		baseUrl,
		credentials: 'include',
		headers: { 'X-KC-CSRF': '1', ...extraHeaders },
	});
}

/** A typed API client for the browser, where the cookie rides along automatically. */
export function createApiClient(baseUrl: string): ApiClient {
	return build(baseUrl);
}

/**
 * A client for SSR loaders/actions. Server-side fetch carries no cookies, so
 * forward the incoming request's Cookie header — the api does its normal Redis
 * session lookup off it. This is the only difference from the browser client.
 */
export function createServerApiClient(baseUrl: string, request: Request): ApiClient {
	const cookie = request.headers.get('cookie');
	return build(baseUrl, cookie ? { cookie } : undefined);
}
